import type { FullReportType, ReportMeasurementItem } from './types';

export const createSampleMeasurement = (
  reportType: FullReportType,
  id: string,
  fieldLabel: string,
  measuredValue: string | number,
  unit: string,
  limit: string,
  status: string,
  extra?: Partial<ReportMeasurementItem>
): ReportMeasurementItem => ({
  id,
  reportType,
  fieldPath: extra?.fieldPath || id,
  fieldLabel,
  measuredValue: String(measuredValue),
  unit,
  limit,
  status,
  ...extra,
  source: extra?.source || 'Sample data',
  reference: extra?.reference || 'Sample data',
  frequency: extra?.frequency || 'per_pipe',
});

export const LOAD_SAMPLE_DATA = false;

export const isSampleDataDeleted = (deletedMeasurementIds: string[] | undefined, id: string) =>
  !LOAD_SAMPLE_DATA || Boolean(deletedMeasurementIds?.includes(id));